angular.module('actionslider', ['pascalprecht.translate']);
